<div *ngIf="client" class="container-fluid p-3">
  <!-- Header -->
  <div class="card shadow-sm mb-3">
    <div class="card-body d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div>
          <h2 class="fw-bold mb-0">{{ client.displayName }}</h2>
          <small class="text-muted">Client Details</small>
        </div>
        <div class="ms-3">
          <button class="btn btn-sm btn-warning me-2" (click)="toggleEditMode()">
            {{ editMode ? 'Save' : 'Edit' }}
          </button>
        </div>
      </div>
      <div class="icon-wrapper position-relative"
           style="width:160px;height:60px;cursor:pointer;"
           (click)="onEditIcon(client)">

        <img *ngIf="client.icon"
             [src]="client.icon
                ? 'data:image/png;base64,' + client.icon
                : 'assets/img/icon.png'"
             alt="Client Icon"
             style="width:160px;height:60px;object-fit:contain;">
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <ul class="nav nav-tabs" id="clientTabs" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#general" type="button">General Info</button>
    </li>
    <!--<li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#encryption" type="button">Encryption</button></li>-->
    <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#datasources" type="button" (click)="activateTab('datasources')">Data Sources</button></li>
    <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#datafeeds" type="button" (click)="activateTab('datafeeds')">Data Feeds</button></li>
    <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#security" type="button" (click)="activateTab('security')">Security Exports</button></li>
    <li class="nav-item" *ngIf="userInfoLoaded && userInfo?.isDeveloper"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#datasets" type="button" (click)="activateTab('datasets')">Data Sets</button></li>
    <li class="nav-item" *ngIf="userInfoLoaded && userInfo?.isDeveloper"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#datapolicies" type="button" (click)="activateTab('datapolicies')">Data Policies</button></li>
    <li class="nav-item" *ngIf="userInfoLoaded && (userInfo?.isGlobalAdmin || userInfo?.isDeveloper)">
      <button class="nav-link" data-bs-toggle="tab" data-bs-target="#clientsync" type="button" (click)="activateTab('clientsync')">Client Sync</button>
    </li>
    <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#wdx" type="button">WDX</button></li>
    <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#reporting" type="button">Reporting</button></li>
    <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#partners" type="button" (click)="activateTab('partners')">Partners</button></li>
    <li class="nav-item" *ngIf="userInfoLoaded && (userInfo?.isGlobalAdmin || userInfo?.isDeveloper)">
      <button class="nav-link" data-bs-toggle="tab" data-bs-target="#roles" type="button" (click)="activateTab('roles')">Roles</button>
    </li>
  </ul>

  <div class="tab-content mt-3">
    <!-- General Info -->
    <div class="tab-pane fade show active" id="general">
      <div class="card shadow-sm">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span class="fw-bold">General Information</span>
        </div>
        <div class="card-body">
          <!-- Display Name -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Display Name</div>
            <div>
              <ng-container *ngIf="!editMode; else editDisplayName">
                {{ client.displayName }}
              </ng-container>
              <ng-template #editDisplayName>
                <div class="d-flex align-items-center"
                     (mouseenter)="showWarning = true"
                     (mouseleave)="showWarning = false">
                  <ejs-textbox [(ngModel)]="client.displayName"
                               cssClass="form-control-sm"
                               style="width: 250px;">
                  </ejs-textbox>
                  <span *ngIf="showWarning"
                        class="text-warning ms-2 small">
                    ⚠️ Changing this may affect encryption
                  </span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Parent Company -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Parent Company</div>
            <div>
              <ng-container *ngIf="!editMode; else editParentCompany">
                {{ client.parentCompanyName || 'None' }}
              </ng-container>
              <ng-template #editParentCompany>
                <ejs-dropdownlist id="parentCompany"
                                  [dataSource]="possibleParents"
                                  [fields]="{ text: 'displayName', value: 'id' }"
                                  placeholder="Select Parent Company"
                                  [(ngModel)]="client.parentClientId"
                                  cssClass="form-control-sm"
                                  style="width: 250px;">
                </ejs-dropdownlist>
              </ng-template>
            </div>
          </div>
          <!-- Enabled -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Enabled</div>
            <div>
              <ng-container *ngIf="!editMode; else editEnabled">
                <span class="badge"
                      [class.bg-success]="client.enabled !== false"
                      [class.bg-danger]="client.enabled === false">
                  {{ client.enabled !== false ? 'Yes' : 'No' }}
                </span>
              </ng-container>

              <ng-template #editEnabled>
                <ejs-switch [(ngModel)]="client.enabled"></ejs-switch>
              </ng-template>
            </div>
          </div>
        </div>
        <!-- Sync Schedule Card -->
        <div class="card shadow-sm mt-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span class="fw-bold">Sync Schedule</span>
            <div class="text-muted small">
              Last updated in CST
            </div>
          </div>
          <div class="card-body">
            <app-cron-schedule-editor [clientId]="client.id"
                                      [jobType]="'Bulk Import'"
                                      [title]="'Edit Schedule: ' + client.displayName"
                                      [currentScheduleEndpoint]="'ClientSettings/CronText'"
                                      [saveScheduleEndpoint]="'ClientSettings/SaveSchedule'"
                                      [deleteScheduleEndpoint]="'ClientSettings/RemoveSchedule'"
                                      [syncEndpoint]="'ClientSettings/RunSync'">
            </app-cron-schedule-editor>
          </div>
        </div>

      </div>
    </div>

    <div class="tab-pane fade" id="encryption" role="tabpanel">
      <div class="card shadow-sm">
        <div class="card-header fw-bold d-flex justify-content-between align-items-center">
          <span>Encryption Settings</span>
          <span *ngIf="editMode" class="small text-warning">
            ⚠️ Changing these values may affect decryption for this client
          </span>
        </div>

        <!--<div class="card-body">-->
          <!-- Encryption Key -->
          <!--<div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Encryption Key</div>
            <div class="d-flex align-items-center">
              <ng-container *ngIf="!editMode; else editKey">
                <input type="{{ showKey ? 'text' : 'password' }}"
                       class="form-control form-control-sm font-monospace"
                       style="min-width: 500px;"
                       [value]="showKey ? client.encryptionKey : maskedKey"
                       disabled>
                <button class="btn btn-outline-secondary btn-sm ms-2"
                        (click)="toggleShowKey()">
                  <i class="bi" [ngClass]="showKey ? 'bi-eye-slash' : 'bi-eye'"></i>
                </button>
              </ng-container>

              <ng-template #editKey>
                <input type="password"
                       class="form-control form-control-sm"
                       [(ngModel)]="client.encryptionKey"
                       placeholder="Enter new key"
                       (change)="confirmEncryptionChange()">
              </ng-template>
            </div>
          </div>-->

          <!-- Encryption Alias -->
          <!--<div class="mb-2 d-flex align-items-center">
          <div class="fw-bold" style="width: 180px;">Encryption Alias</div>
          <div>
            <ng-container *ngIf="!editMode; else editAlias">
              {{ encryptionAlias || 'N/A' }}
            </ng-container>
            <ng-template #editAlias>
              <input type="text"
                     class="form-control form-control-sm"
                     [(ngModel)]="encryptionAlias">
            </ng-template>
          </div>
        </div>-->
          <!-- Info Message -->
          <!--<div class="alert alert-info small mt-3 mb-0">
            <b>Note:</b> The encryption uses
            <code>EncryptionKey + (EncryptionAlias ?? DisplayName)</code>
            for decryption.
            Changing any of these values may require re-encrypting related configs.
          </div>
        </div>-->
      </div>
    </div>

    <!-- WDX -->
    <div class="tab-pane fade" id="wdx">
      <div class="card shadow-sm">
        <div class="card-header fw-bold">WDX Settings</div>
        <div class="card-body">
          <!-- WDX Market ID -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">WDX Market ID</div>
            <div>
              <!-- View Mode -->
              <ng-container *ngIf="!editMode; else editWdxMarketId">
                {{ clientLink.wdxMarketId ?? 'none' }}
              </ng-container>

              <!-- Edit Mode -->
              <ng-template #editWdxMarketId>
                <div class="d-flex align-items-center"
                     (mouseenter)="showWarning = true"
                     (mouseleave)="showWarning = false">
                  <ejs-textbox [(ngModel)]="clientLink.wdxMarketId"
                               cssClass="form-control-sm"
                               style="width: 250px;">
                  </ejs-textbox>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">WDX User ID</div>
            <div>
              <!-- View Mode -->
              <ng-container *ngIf="!editMode; else editwdxUserId">
                {{ clientLink.wdxUserId ?? 'none' }}
              </ng-container>

              <!-- Edit Mode -->
              <ng-template #editwdxUserId>
                <div class="d-flex align-items-center"
                     (mouseenter)="showWarning = true"
                     (mouseleave)="showWarning = false">
                  <ejs-textbox [(ngModel)]="clientLink.wdxUserId"
                               cssClass="form-control-sm"
                               style="width: 250px;">
                  </ejs-textbox>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Reporting -->
    <div class="tab-pane fade" id="reporting">
      <div class="card shadow-sm">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span class="fw-bold">Reporting</span>
        </div>

        <div class="card-body">
          <!-- Use Backfill Mode -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Use Backfill Mode</div>

            <div>
              <ng-container *ngIf="client?.reportsConfig as rc">

                <!-- View -->
                <ng-container *ngIf="!editMode; else editBackfill">
                  <span class="badge"
                        [class.bg-success]="rc.backfillReportMode"
                        [class.bg-danger]="!rc.backfillReportMode">
                    {{ rc.backfillReportMode ? 'Yes' : 'No' }}
                  </span>
                </ng-container>

                <!-- Edit -->
                <ng-template #editBackfill>
                  <ejs-switch [(ngModel)]="rc.backfillReportMode"></ejs-switch>
                </ng-template>

              </ng-container>
            </div>
          </div>

          <!-- Max # Reports Per Run -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Max # Reports Per Run</div>

            <div>
              <ng-container *ngIf="client?.reportsConfig as rc">

                <!-- View -->
                <ng-container *ngIf="!editMode; else editLimit">
                  {{ rc.backfillReportLimit ?? 'N/A' }}
                </ng-container>

                <!-- Edit -->
                <ng-template #editLimit>
                  <ejs-numerictextbox [(ngModel)]="rc.backfillReportLimit"
                                      cssClass="form-control-sm"
                                      [min]="0"
                                      [step]="1"
                                      format="n0"
                                      decimals="0"
                                      style="width: 150px;">
                  </ejs-numerictextbox>
                </ng-template>

              </ng-container>
            </div>
          </div>

          <!-- Max Time Per Run -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Max Time Per Run (hours)</div>

            <div>
              <ng-container *ngIf="client?.reportsConfig as rc">

                <!-- View -->
                <ng-container *ngIf="!editMode; else editTime">
                  {{ rc.backfillTimeLimitHours ?? 'N/A' }}
                </ng-container>

                <!-- Edit -->
                <ng-template #editTime>
                  <ejs-numerictextbox [(ngModel)]="rc.backfillTimeLimitHours"
                                      cssClass="form-control-sm"
                                      [min]="0"
                                      [step]="1"
                                      decimals="0"
                                      format="n0"
                                      style="width: 150px;">
                  </ejs-numerictextbox>
                </ng-template>

              </ng-container>
            </div>
          </div>
          <!-- Enable Reports -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Enable Reports?</div>

            <div>
              <ng-container *ngIf="client?.reportsConfig as rc">

                <!-- View Mode -->
                <ng-container *ngIf="!editMode; else editEnableReports">
                  <span class="badge"
                        [class.bg-success]="rc.reportsEnabled"
                        [class.bg-danger]="!rc.reportsEnabled">
                    {{ rc.reportsEnabled ? 'Yes' : 'No' }}
                  </span>
                </ng-container>

                <!-- Edit Mode -->
                <ng-template #editEnableReports>
                  <ejs-switch [(ngModel)]="rc.reportsEnabled"></ejs-switch>
                </ng-template>

              </ng-container>
            </div>
          </div>
          <!-- Data Model -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Data Model</div>

            <div>
              <ng-container *ngIf="client?.reportsConfig as rc">

                <!-- View -->
                <ng-container *ngIf="!editMode; else editDataModel">
                  {{ rc.dataModel || 'WellChron' }}
                </ng-container>

                <!-- Edit -->
                <ng-template #editDataModel>
                  <ejs-dropdownlist id="dataModel"
                                    [dataSource]="dataModels"
                                    placeholder="Select Data Model"
                                    [showClearButton]="true"
                                    [(ngModel)]="dataModelSelection"
                                    cssClass="form-control-sm"
                                    style="width: 250px;">
                  </ejs-dropdownlist>
                </ng-template>

              </ng-container>
            </div>
          </div>
          <!-- Report Recipients -->
          <div class="mb-2 d-flex align-items-center">
            <div class="fw-bold" style="width: 180px;">Report Recipients</div>

            <div>
              <ng-container *ngIf="client?.reportsConfig as rc">

                <!-- View -->
                <ng-container *ngIf="!editMode; else editReportRecipients">
                  {{ (rc.reportRecipients && rc.reportRecipients.length) ? rc.reportRecipients.join('; ') : '—' }}
                </ng-container>

                <!-- Edit -->
                <ng-template #editReportRecipients>
                  <input class="form-control form-control-sm"
                         [(ngModel)]="reportRecipientsText"
                         placeholder="name@company.com; name2@company.com"
                         style="width: 350px;">
                </ng-template>

              </ng-container>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="tab-pane fade" id="datasources">
      <app-client-data-source *ngIf="tabsVisited.has('datasources') && clientId" [clientId]="clientId"></app-client-data-source>
    </div>

    <div class="tab-pane fade" id="datafeeds">
      <app-client-datafeed *ngIf="tabsVisited.has('datafeeds') && clientId" [clientId]="clientId"></app-client-datafeed>
    </div>
    <div class="tab-pane fade" id="security">
      <client-security-exports *ngIf="tabsVisited.has('security') && clientId" [clientId]="clientId"></client-security-exports>
    </div>

    <!-- Data Sets — developer only -->
    <div class="tab-pane fade" id="datasets">
      <app-client-dataset-editor *ngIf="tabsVisited.has('datasets') && clientId" [clientId]="clientId"></app-client-dataset-editor>
    </div>

    <!-- Data Policies — developer only -->
    <div class="tab-pane fade" id="datapolicies">
      <app-data-policy-editor *ngIf="tabsVisited.has('datapolicies') && clientId" [clientId]="clientId"></app-data-policy-editor>
    </div>

    <!-- Client Sync — global admin / developer only -->
    <div class="tab-pane fade" id="clientsync" *ngIf="userInfoLoaded && (userInfo?.isGlobalAdmin || userInfo?.isDeveloper)">
      <app-client-sync-editor *ngIf="tabsVisited.has('clientsync') && clientId" [clientId]="clientId"></app-client-sync-editor>
    </div>

    <!-- Partners -->
    <div class="tab-pane fade" id="partners">
      <app-partner-assignment *ngIf="tabsVisited.has('partners') && clientId" [clientId]="clientId"></app-partner-assignment>
    </div>

    <!-- Roles — global admin / developer only -->
    <div class="tab-pane fade" id="roles" *ngIf="userInfoLoaded && (userInfo?.isGlobalAdmin || userInfo?.isDeveloper)">
      <div class="card shadow-sm" *ngIf="tabsVisited.has('roles') && clientId">
        <div class="card-header fw-bold">Client Roles</div>
        <div class="card-body">
          <app-roles-panel mode="client" [targetId]="clientId" [readonly]="false" />
        </div>
      </div>
    </div>
  </div>
